import { z, isoZ } from 'my-zod'

export const dealersModel = z.object({
  id: z.number().int(),
  businessName: z.string(),
  dealerNumber: z.string().nullable().describe('Assigned by Polaris to identify the dealer within various dealer systems.'),
  buyerEmail: z.string().array().nullable().describe('Emails associated with buyer primary contact.'),
  buyerPrimaryContact: z
    .string()
    .nullable()
    .describe(
      'Primary contact associated with person at the dealership responsible for buying vehicles that Polaris Experience is selling at end of lease.'
    ),
  buyerPrimaryPhone: z.string().nullable().describe('Phone associated with buyer primary contact.'),
  dealerEmail: z.string().array().nullable().describe('emails associated with dealer primary contact.'),
  dealerPrimaryContact: z
    .string()
    .nullable()
    .describe('Primary contact associated with person at dealership responsible for business relationship with outfitters.'),
  dealerPrimaryPhone: z.string().nullable().describe('Primary phone associated with dealer primary contact.'),
  address: z.string().nullable(),
  city: z.string().nullable(),
  stateProvinceRegion: z.string().nullable(),
  postalZipCode: z.string().nullable(),
  country: z.string().nullable(),
  notes: z.string().nullable(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type dealersModel = z.infer<typeof dealersModel>
